import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const date: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(3),

  input: {
    width: '100%',
  },
  /* PREPEND HERE */
};

export default date;
